var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubbento32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 2.1875V10.9375L17.5 19.6875L0 10.9375V2.1875C0 1.60734 0.184374 1.05094 0.512563 0.640704C0.840752 0.230469 1.28587 0 1.75 0H33.25C33.7141 0 34.1592 0.230469 34.4874 0.640704C34.8156 1.05094 35 1.60734 35 2.1875ZM0 15.6494V32.8125C0 33.3927 0.184374 33.9491 0.512563 34.3593C0.840752 34.7695 1.28587 35 1.75 35H33.25C33.7141 35 34.1592 34.7695 34.4874 34.3593C34.8156 33.9491 35 33.3927 35 32.8125V15.6494L17.5 24.3994L0 15.6494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubbento32);
export default __webpack_public_path__ + "static/media/subbento3_2.2d1f77516473a6fa3562590b5936c214.svg";
export { ForwardRef as ReactComponent };